/**
 * RESPONSIBILITY: the photograph across the top of the About page.
 *
 * A real <img> rather than a background, so the picture is in the document: it carries
 * the alt text an editor wrote, and a browser can treat it as the page's largest image
 * instead of discovering it in a stylesheet.
 */
import type { AboutHeroSection } from '@app/sections';
import { Picture } from '../commons/Picture';

export function AboutHeroBanner({ c }: { c: AboutHeroSection }) {
  return (
    <section className="ab-hero">
      <Picture value={c.image} alt={c.image?.alt} className="ab-hero__img" />
      <span className="ab-hero__dim" aria-hidden="true" />
      <div className="wrap ab-hero__content">
        {c.eyebrow && <p className="ab-hero__eyebrow">{c.eyebrow}</p>}
        <h1 className="ab-hero__h1">{c.heading}</h1>
        {c.intro && <p className="ab-hero__sub">{c.intro}</p>}
      </div>
    </section>
  );
}
